// Indonesian has no plural forms: "1 malam", "3 malam".
const n = (text) => ({ n }) => text.replace("{n}", n);

const id = {
  nights: n("{n} malam"),
  adults: n("{n} dewasa"),
  children: n("{n} anak"),
  rooms: n("{n} kamar"),
  beds: n("{n} tempat tidur"),
  upToGuests: n("Maks. {n} tamu"),
  roomTypesAvailable: n("{n} tipe kamar tersedia"),
  photosCount: n("{n} foto"),
  rateOptions: n("{n} pilihan tarif"),

  "nav.signIn": "Masuk",
  "nav.home": "Beranda {name}",
  "lang.title": "Pilih bahasa",
  "lang.label": "Bahasa",
  "footer.rights": "Hak cipta dilindungi",
  "footer.bookingBy": "Pemesanan oleh",
  "footer.poweredBy": "Didukung oleh",

  "hero.welcome": "Selamat datang di {name}",
  "hero.welcomePlain": "Selamat datang",
  "hero.photos": "Foto utama",
  "hero.photo": "Foto {n}",

  "group.eyebrow": "Hotel kami",
  "group.title": "Pilih tempat menginap",
  "group.count": ({ n }) => `${n} hotel. Pilih untuk melihat kamar dan tarif.`,
  "group.empty": "Belum ada hotel yang terdaftar.",
  "group.visit": "Lihat kamar & pesan",

  "home.roomsEyebrow": "Kamar & tarif",
  "home.factsEyebrow": "Di kamar kami",
  "home.factsTitle": "Yang tersedia untuk Anda",
  "home.galleryEyebrow": "Galeri",
  "home.galleryTitle": "Lihat-lihat dulu",
  "home.morePhotos": "+{n} foto",
  "home.locationEyebrow": "Lokasi",
  "home.directions": "Petunjuk arah",
  "home.mapTitle": "Peta lokasi {name}",

  "search.label": "Cari kamar",
  "search.dates": "Check-in — Check-out",
  "search.guests": "Tamu",
  "search.adults": "Dewasa",
  "search.children": "Anak",
  "search.fewer": "Kurangi {what}",
  "search.more": "Tambah {what}",
  "search.chooseDates": "Pilih tanggal",
  "search.chooseGuests": "Pilih jumlah tamu",
  "search.pickCheckout": "Sekarang pilih tanggal check-out",
  "search.done": "Selesai",
  "search.submit": "Cari",

  "trust.direct": "Pesan langsung ke hotel",
  "trust.secure": "Pembayaran aman",
  "trust.email": "Konfirmasi dikirim lewat email",

  "results.finding": "Mencari kamar…",
  "results.choose": "Pilih kamar Anda",
  "results.none": "Tidak ada kamar tersedia",
  "results.change": "Ubah pencarian",
  "results.loadingAria": "Mencari kamar yang tersedia",
  "err.availability": "Ketersediaan kamar tidak dapat dimuat.",
  "err.priced": "Harga kamar tidak dapat dihitung. Silakan coba lagi sebentar lagi.",

  "card.onlyLeft": "Tinggal {n} kamar",
  "card.payAtHotel": "Bisa bayar di hotel",
  "card.from": "Mulai dari",
  "card.perNight": "/ malam",
  "card.total": "{total} untuk {nights} · termasuk biaya layanan",
  "card.seeRates": "Lihat tarif",
  "card.totalShort": "total untuk {nights}, termasuk biaya layanan",
  "card.more": "+{n} lainnya",
  "media.soon": "Foto segera hadir",

  "empty.title": "Kamar penuh untuk tanggal ini",
  "empty.body": "Coba tanggal lain, atau kurangi jumlah tamu per kamar.",
  "empty.change": "Ubah tanggal",

  "panel.close": "Tutup",
  "panel.prev": "Foto sebelumnya",
  "panel.next": "Foto berikutnya",
  "panel.photoOf": "{name} ({n} dari {total})",
  "panel.popular": "Fasilitas populer",
  "panel.offers": "Semua fasilitas kamar",
  "panel.chooseRate": "Pilih tarif",
  "panel.rateNote": "Harga untuk seluruh masa menginap, sudah termasuk biaya layanan.",
  "panel.rates": "Tarif",
  "panel.roomRate": "Tarif kamar",
  "panel.payAtHotel": "Bayar di hotel, tanpa bayar hari ini",
  "panel.payNow": "Bayar sekarang",
  "panel.perNight": "{price} / malam",
  "panel.rooms": "Kamar",
  "panel.fewerRooms": "Kurangi kamar",
  "panel.moreRooms": "Tambah kamar",
  "panel.total": "Total · {nights}",
  "panel.reserve": "Pesan",

  "fac.amenities": "Fasilitas",
  "fac.view": "Pemandangan",
  "fac.bedroom": "Kamar tidur",
  "fac.bathroom": "Kamar mandi",
  "fac.entertainment": "Hiburan",
  "fac.kitchen": "Dapur",
  "fac.room": "Di dalam kamar",
  "fac.floor": "Lantai",
  "fac.outdoor": "Luar ruangan",

  "steps.label": "Tahapan pemesanan",
  "steps.details": "Data Anda",
  "steps.payment": "Pembayaran",
  "steps.confirmed": "Terkonfirmasi",
  "checkout.back": "Kembali ke kamar",
  "checkout.title": "Sedikit lagi",
  "checkout.who": "Siapa yang akan check-in?",
  "checkout.whoSub": "Konfirmasi akan kami kirim ke sini. Nama harus sesuai dengan identitas yang ditunjukkan saat check-in.",
  "checkout.rideum": ({ logo }) => <>Punya akun {logo}? Masuk, dan data Anda terisi otomatis.</>,
  "form.firstName": "Nama depan",
  "form.lastName": "Nama belakang",
  "form.email": "Email",
  "form.mobile": "Nomor ponsel",
  "form.emailPlaceholder": "nama@contoh.com",
  "form.emailHint": "Untuk konfirmasi, dan untuk membatalkan secara online.",
  "form.mobileHint": "Agar hotel dapat menghubungi Anda terkait masa menginap.",
  "form.firstNameReq": "Masukkan nama depan Anda.",
  "form.lastNameReq": "Masukkan nama belakang Anda.",
  "form.emailInvalid": "Masukkan alamat email yang valid.",
  "form.contactMissing": "Masukkan nomor ponsel atau email agar hotel dapat menghubungi Anda.",
  "form.payNextTitle": "Pembayaran di langkah berikutnya",
  "form.payNextBody": "Tarif ini dibayar penuh melalui pembayaran yang aman. Pemesanan terkonfirmasi setelah pembayaran berhasil.",
  "form.payHotelTitle": "Tidak perlu bayar hari ini",
  "form.payHotelBody": "Anda membayar di hotel saat check-in. Kamar langsung terkonfirmasi setelah Anda selesai.",
  "form.privacy": "Data Anda hanya dibagikan kepada hotel.",
  "form.continuePay": "Lanjut ke pembayaran",
  "form.confirm": "Konfirmasi pemesanan",
  "err.booking": "Pemesanan gagal.",

  "sum.checkin": "Check-in",
  "sum.checkout": "Check-out",
  "sum.guests": "Tamu",
  "sum.rooms": "Kamar",
  "sum.cancellation": "Pembatalan",
  "sum.payment": "Pembayaran",
  "sum.payAtHotel": "Bayar di hotel",
  "sum.payNow": "Bayar sekarang",
  "sum.roomsNights": "{rooms} × {nights}",
  "sum.extraAdults": "Tambahan dewasa ({n})",
  "sum.service": "Biaya layanan ({pct}%)",
  "sum.total": "Total",
  "sum.idr": "Ditagih dalam IDR dengan kurs hari ini.",
  "sum.bookingFor": "Pemesanan atas nama {name}",

  "pay.back": "Kembali ke data Anda",
  "pay.title": "Bayar dengan aman",
  "pay.loadError": "Formulir pembayaran tidak dapat dimuat. Muat ulang halaman dan coba lagi.",
  "pay.waitingTitle": "Kami menunggu pembayaran Anda",
  "pay.waitingBody": "Kamar Anda ditahan selama {min} menit sejak Anda memulai. Ikuti petunjuk pembayaran yang diberikan — setelah itu pembayaran tidak dapat diterima dan kamar dilepas. Kami akan mengirim email begitu pembayaran terkonfirmasi, jadi Anda boleh menutup halaman ini.",
  "pay.hi": "Halo {name}, satu langkah lagi",
  "pay.sub": "Tekan Bayar untuk memilih cara pembayaran. Pemesanan terkonfirmasi begitu pembayaran berhasil.",
  "pay.pay": "Bayar {amount}",
  "pay.retry": "Coba lagi {amount}",
  "pay.loading": "Memuat formulir aman…",
  "pay.secure": "Pembayaran diproses dengan aman oleh Midtrans. Kami tidak pernah melihat data kartu Anda.",
  "pay.errConfig": "Pengaturan pembayaran tidak dapat dimuat.",
  "pay.errNotReady": "Formulir pembayaran masih dimuat. Coba lagi sebentar lagi.",
  "pay.errFailed": "Pembayaran gagal.",
  "pay.errDeclined": "Pembayaran tidak berhasil. Anda dapat mencoba lagi.",
  "pay.errOpen": "Formulir pembayaran tidak dapat dibuka. Silakan coba lagi.",

  "loader.title": "Mohon tunggu sebentar",
  "loader.body": "Permintaan Anda sedang diproses. Jangan tutup jendela ini atau meninggalkan halaman.",
  "loader.loading": "Memuat…",

  "conf.loading": "Memuat pemesanan Anda…",
  "conf.notFoundTitle": "Pemesanan tidak ditemukan",
  "conf.notFoundBody": "Periksa tautan di email konfirmasi, atau hubungi hotel dengan nomor pemesanan Anda.",
  "conf.backHotel": "Kembali ke hotel",
  "conf.theHotel": "hotel",
  "conf.booked": ({ name }) => (name ? `Pemesanan berhasil, ${name}!` : "Pemesanan berhasil!"),
  "conf.leadEmail": ({ hotel, email }) => <>Masa menginap Anda di <strong>{hotel}</strong> sudah terkonfirmasi. Detailnya sudah kami kirim ke <strong>{email}</strong>.</>,
  "conf.leadNoEmail": ({ hotel }) => <>Masa menginap Anda di <strong>{hotel}</strong> sudah terkonfirmasi. Simpan nomor pemesanan untuk check-in.</>,
  "conf.waitTitle": "Kami menunggu pembayaran Anda",
  "conf.waitLead": ({ email }) => <>Kamar Anda ditahan sampai pembayaran diterima.{email ? <> Kami akan mengirim email ke <strong>{email}</strong> begitu terkonfirmasi.</> : null}</>,
  "conf.cancelTitle": "Pemesanan ini dibatalkan",
  "conf.cancelLead": ({ hotel }) => <>Masa menginap Anda di <strong>{hotel}</strong> tidak akan berlangsung.</>,
  "conf.bookingNo": "No. pemesanan",
  "conf.copy": "Salin",
  "conf.copied": "Tersalin",
  "conf.copyAria": "Salin nomor pemesanan",
  "conf.guest": "Tamu",
  "conf.roomsGuests": "Kamar · tamu",
  "conf.email": "Email",
  "conf.mobile": "Ponsel",
  "conf.policy": "Kebijakan pembatalan",
  "conf.showAtDesk": "Tunjukkan halaman ini atau nomor pemesanan di resepsionis saat Anda tiba.",
  "conf.print": "Cetak",
  "print.title": "Konfirmasi Pemesanan",
  "print.bookingNo": "No. pemesanan",
  "print.guest": "Tamu",
  "print.email": "Email",
  "print.phone": "Telepon",
  "print.rooms": "Kamar",
  "print.adults": "Dewasa",
  "print.children": "Anak",
  "print.roomType": "Tipe kamar",
  "print.policy": "Kebijakan pembatalan",
  "print.arrival": "Kedatangan",
  "print.departure": "Keberangkatan",

  "cx.cancelledTitle": "Pemesanan ini telah dibatalkan.",
  "cx.cancelledBody": "Pengembalian dana mengikuti kebijakan pembatalan di atas. Hotel akan mengaturnya langsung dan menghubungi Anda — dana tidak otomatis dikembalikan ke kartu Anda.",
  "cx.doneTitle": "Pemesanan Anda telah dibatalkan.",
  "cx.refundDue": "Anda berhak atas pengembalian dana sebesar {amount}. Hotel akan mengaturnya langsung dan menghubungi Anda soal tujuan pengirimannya.",
  "cx.noRefund": "Tidak ada pengembalian dana sesuai kebijakan pembatalan.",
  "cx.plansChanged": "Rencana berubah?",
  "cx.cancelLink": "Batalkan pemesanan ini",
  "cx.title": "Batalkan pemesanan ini",
  "cx.intro": "Masukkan email atau nomor ponsel yang dipakai saat memesan, lalu kami tunjukkan biaya pembatalannya. Belum ada yang dibatalkan.",
  "cx.placeholder": "anda@contoh.com atau +62…",
  "cx.checking": "Memeriksa…",
  "cx.showTerms": "Lihat ketentuan pembatalan",
  "cx.fee": "Biaya pembatalan",
  "cx.refund": "Pengembalian dana untuk Anda",
  "cx.outstanding": "Masih harus dibayar ke hotel",
  "cx.irreversible": "Tindakan ini tidak dapat dibatalkan. Pengembalian dana diatur oleh hotel, tidak otomatis dikembalikan ke kartu Anda.",
  "cx.cancelling": "Membatalkan…",
  "cx.confirm": "Konfirmasi pembatalan",
  "cx.keep": "Tetap pesan",
  "cx.generic": "Terjadi kesalahan. Silakan coba lagi.",
  "cx.FullyRefundable": "Pembatalan gratis",
  "cx.PartiallyRefundable": "Sebagian dapat dikembalikan",
  "cx.NonRefundable": "Tidak dapat dikembalikan",

  "auth.signIn": "Masuk",
  "auth.create": "Buat akun",
  "auth.loading": "Memuat…",
  "auth.what": "Akun Rideum menyimpan data Anda, jadi pemesanan berikutnya lebih cepat.",
  "login.title": "Masuk ke Rideum",
  "login.sub": "Gunakan email atau nomor ponsel akun Rideum Anda.",
  "login.emailOrMobile": "Email atau nomor ponsel",
  "login.placeholder": "nama@contoh.com atau 0812…",
  "login.required": "Masukkan email atau nomor ponsel Anda.",
  "login.invalid": "Email atau nomor ponsel tidak valid.",
  "login.continue": "Lanjut",
  "login.mobileNotFound": "Tidak ada akun Rideum dengan nomor {phone}.",
  "login.resetDone": "Kata sandi Anda telah diatur ulang. Silakan periksa email Anda.",
  "login.forgotTitle": "Lupa kata sandi?",
  "login.forgotSub": "Masukkan email Rideum Anda dan kami kirimkan kata sandi baru.",
  "login.registeredEmail": "Email akun Rideum",
  "login.emailRequired": "Masukkan email Anda.",
  "login.emailInvalid": "Alamat email tidak valid.",
  "login.sendReset": "Kirim kata sandi baru",
  "login.backToSignIn": "Kembali ke halaman masuk",
  "login.verifyTitle": "Verifikasi akun Rideum Anda",
  "login.verifyEmail": () => <>Kami telah mengirim <strong>kata sandi sementara</strong> ke email Anda. Gunakan untuk masuk.</>,
  "login.welcome": "Selamat datang kembali di Rideum",
  "login.password": "Kata sandi",
  "login.passwordPlaceholder": "Kata sandi Rideum Anda",
  "login.passwordRequired": "Masukkan kata sandi Anda.",
  "login.forgot": "Lupa kata sandi?",
  "login.signIn": "Masuk",
  "login.back": "Kembali",
  "login.mobileTitle": "Masuk dengan ponsel",
  "login.sms": () => <>Kami telah mengirim SMS. Masukkan <strong>kode 4 digit</strong> untuk melanjutkan.</>,
  "login.verifySignIn": "Verifikasi dan masuk",
  "login.changeMethod": "Gunakan email atau nomor lain",
  "otp.expired": "Kode kedaluwarsa. Kirim kode baru",
  "otp.expiresIn": "Kode berlaku {time}",

  "reg.title": "Buat akun Rideum",
  "reg.sub": "Gratis, dan data Anda tersimpan untuk pemesanan berikutnya.",
  "reg.withEmail": "Email",
  "reg.withMobile": "Ponsel",
  "reg.emailReq": "Masukkan email Anda.",
  "reg.emailInvalid": "Alamat email tidak valid.",
  "reg.emailHint": "Dipakai untuk masuk, dan kata sandi akan kami kirim ke email ini.",
  "reg.mobileHint": "Dipakai untuk masuk dengan kode yang kami kirim lewat SMS.",
  "reg.agree": ({ terms, privacy }) => <>Dengan membuat akun, Anda menyetujui {terms} dan {privacy}.</>,
  "reg.create": "Buat akun Rideum",
  "reg.have": "Sudah punya akun Rideum?",
  terms: "Syarat & Ketentuan",
  "url.terms": "https://www.rideum.io/id/legal/terms",
  "url.privacy": "https://www.rideum.io/id/legal/privacy",
  privacy: "Kebijakan Privasi",

  "prof.fullName": "Nama lengkap",
  "prof.email": "Email",
  "prof.mobile": "Ponsel",
  "prof.notProvided": "Belum diisi",
  "prof.birthday": "Tanggal lahir",
  "prof.addBirthday": "Belum diisi",
  "prof.account": "Akun",
  "prof.guest": "Tamu",
  "prof.changePassword": "Ubah kata sandi",
  "prof.signOut": "Keluar",
  "prof.close": "Tutup",

  "pw.title": "Ubah kata sandi",
  "pw.sub": "Pilih kata sandi yang tidak Anda pakai di tempat lain.",
  "pw.current": "Kata sandi saat ini",
  "pw.currentReq": "Masukkan kata sandi saat ini.",
  "pw.new": "Kata sandi baru",
  "pw.newPlaceholder": "Minimal 8 karakter",
  "pw.newReq": "Masukkan kata sandi baru.",
  "pw.min": "Minimal 8 karakter.",
  "pw.mix": "Gunakan minimal 3 dari: huruf besar, huruf kecil, angka, simbol.",
  "pw.update": "Perbarui kata sandi",
  "pw.back": "Kembali ke profil",
  "pw.changed": "Kata sandi Anda telah diubah.",
};

export default id;
